var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPages({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6259_9585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 24.002H0V6.07031H24V24.002ZM0.827593 23.1744H23.1724V6.89796H0.827593V23.1744Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 3.24219H0V4.06978H24V3.24219Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 0.414062H0V1.24166H24V0.414062Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6259_9585"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPages);
export default __webpack_public_path__ + "static/media/Pages.e5160d95691b9ab44b3439412a163130.svg";
export { ForwardRef as ReactComponent };